import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal } from "../ui";
import { useBonuses } from "../../context/bonusContext";
import { bonusLotteriesText, formatBonusLongDate } from "../../utils/bonusRules";
import styles from "./Bonus.module.css";

/**
 * "¡Ganaste 1 fracción/billete gratis!" — se abre cuando, tras confirmarse una
 * recarga, aparece un bono de bienvenida nuevo (ver BonusProvider.detectNewWelcomeBonus).
 */
export default function BonusCelebrationModal() {
  const navigate = useNavigate();
  const { celebration, closeCelebration } = useBonuses();

  if (!celebration) return null;

  const label = String(celebration.label || "1 fracción gratis");
  const expires = formatBonusLongDate(celebration.expires_at);

  const useNow = () => {
    closeCelebration();
    navigate("/apuestas");
  };

  return (
    <Modal isOpen onClose={closeCelebration} size="sm">
      <div className={styles.celebration}>
        <span className={styles.celebrationIcon} aria-hidden="true">
          <FontAwesomeIcon icon={faGift} />
        </span>
        <h2 className={styles.celebrationTitle}>¡Ganaste {label}!</h2>
        <p className={styles.celebrationText}>
          Gracias por tu primera recarga. Elige tu número en la lotería que quieras y
          paga con tu bono en el carrito.
        </p>
        <ul className={styles.celebrationFacts}>
          {expires && <li>Úsalo antes del {expires}.</li>}
          <li>{bonusLotteriesText(celebration)}.</li>
        </ul>
        <div className={styles.celebrationActions}>
          <Button variant="primary" fullWidth onClick={useNow}>
            Usar ahora
          </Button>
          <Button variant="ghost" fullWidth onClick={closeCelebration}>
            Más tarde
          </Button>
        </div>
      </div>
    </Modal>
  );
}
